import React from "react"
import { Table } from "react-bootstrap"

import { deepCamelizeKeys } from "@/utils"
import formatRate from "@/pricing/formatRate"

const BulkRatesheetView = ({ value, currencyCode = undefined }): JSX.Element => {
  value = deepCamelizeKeys(value)
  const currency = value.currencyCode || currencyCode

  return (
    <Table>
      <thead className="mb-2">
        <tr>
          <th>Bulk Rate</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{formatRate(value.bulkRate, currency)}</td>
        </tr>
      </tbody>
    </Table>
  )
}

export default BulkRatesheetView
